import { IconsPlugin } from 'utils/icons';
import UserLoginModal from 'components/UserLoginModal.vue';
import UserRegistration from 'components/UserRegistration.vue';
import UserForgotPassword from 'components/UserForgotPassword.vue';
import UserMenu from 'components/UserMenu.vue';
import { cloneObject, requireConfirmation } from 'utils';
import logger from 'utils/logger';
import Modal from 'components/Modal.vue';
import MainMenu from 'components/menu/desktop/Menu.vue';
import MobileMenu from 'components/menu/mobile/Menu.vue';
import ContactForm from 'components/forms/ContactForm.vue';
import Alert from 'components/Alert.vue';
import CookieModal from 'components/CookieModal.vue';
import ChangeInitialPasswordModal from 'components/ChangeInitialPasswordModal.vue';
import Tooltip from 'components/Tooltip.vue';
import ComparisonBasket from 'components/product-comparison/ComparisonBasket.vue';
import notification from 'utils/noty';
import RequireCountryConfirmationModal from 'components/RequireCountryConfirmationModal.vue';
import BackToTopButton from 'components/BackToTopButton.vue';
import ChangedMySheetsHint from 'components/product-sheets/ChangedMySheetsHint.vue';
import PrivacyPolicyModal from 'components/PrivacyPolicyModal.vue';
import Checkbox from 'components/Checkbox.vue';
import ValidationsPlugin from './validations-plugin';

/**
 * Convenience function to dispatch generic/trackEvent actions.
 *
 * @param {string} category e.g. "movie"
 * @param {string} action e.g. "rate"
 * @param {array|string|null|boolean|object} name e.g. "Iron Man"
 * @param {string|number|null} value 10
 */
const trackEvent = function trackEvent(category, action, name = null, value = null) {
  this.$store.dispatch('generic/trackEvent', {
    category, action, name, value
  });
};

export default {
  install(app) {
    logger.init(app);

    app.config.globalProperties.$cloneObject = cloneObject;
    app.config.globalProperties.$trackEvent = trackEvent;
    app.config.globalProperties.$requireConfirmation = requireConfirmation;
    app.config.globalProperties.$notification = notification;

    app.config.compilerOptions.whitespace = 'preserve';

    app.component('user-login-modal', UserLoginModal);
    app.component('user-registration', UserRegistration);
    app.component('user-forgot-password', UserForgotPassword);
    app.component('main-menu', MainMenu);
    app.component('user-menu', UserMenu);
    app.component('modal', Modal);
    app.component('mobile-menu', MobileMenu);
    app.component('contact-form', ContactForm);
    app.component('alert', Alert);
    app.component('cookie-modal', CookieModal);
    app.component('change-initial-password-modal', ChangeInitialPasswordModal);
    app.component('tooltip', Tooltip);
    app.component('comparison-basket', ComparisonBasket);
    app.component('require-country-confirmation-modal', RequireCountryConfirmationModal);
    app.component('back-to-top-button', BackToTopButton);
    app.component('changed-my-sheets-hint', ChangedMySheetsHint);
    app.component('privacy-policy-modal', PrivacyPolicyModal);
    app.component('checkbox', Checkbox);

    app.use(IconsPlugin);
    app.use(ValidationsPlugin);
  }
};
